__turbopack_context__.v({
  "arrowIcon": "dKZDZa_arrowIcon",
  "item": "dKZDZa_item",
  "itemLeft": "dKZDZa_itemLeft",
  "reasonForVisitIcon": "dKZDZa_reasonForVisitIcon",
  "reasonForVisitIconBrokenTooth": "dKZDZa_reasonForVisitIconBrokenTooth",
  "reasonForVisitIconDentalImplants": "dKZDZa_reasonForVisitIconDentalImplants",
  "reasonForVisitIconDentures": "dKZDZa_reasonForVisitIconDentures",
  "reasonForVisitIconEmergency": "dKZDZa_reasonForVisitIconEmergency",
  "reasonForVisitIconMotto": "dKZDZa_reasonForVisitIconMotto",
  "reasonForVisitIconOtherCheckup": "dKZDZa_reasonForVisitIconOtherCheckup",
  "root": "dKZDZa_root",
});
